import type { ReactNode } from 'react';

/**
 * Número de destaque com rótulo.
 *
 * O rótulo vem ANTES do número na ordem de leitura do DOM, e depois no visual.
 * Sem isso, um leitor de tela anuncia "128" e só então "contatos" — número sem
 * unidade não é informação. A inversão é feita com `flex-direction`, que não
 * muda a ordem do DOM.
 */
export function Stat({ rotulo, valor, apoio }: { rotulo: string; valor: ReactNode; apoio?: string }) {
  return (
    <div className="stat">
      <span className="stat__rotulo">{rotulo}</span>
      <span className="stat__valor">{valor}</span>
      {apoio && <span className="stat__apoio">{apoio}</span>}
    </div>
  );
}
